<template>
    <v-ons-page>
        <div class="header">
            <img src="../assets/hynds-vip.svg" width="140px">
        </div>


        <div v-show="loading" class="text-center page-progress-loader">
            <v-ons-progress-circular
                indeterminate
                ></v-ons-progress-circular>
        </div>

        <form v-show="!loading" v-on:submit="doNothing" class="login-form">
            <h2>Login</h2>

            <div>
                <label for="email">Email</label>
                <v-ons-input
                    input-id="email"
                    placeholder=""
                    v-model="email"
                    type="email"
                    class="text-input__container"
                    ></v-ons-input>
            </div>
            <div>
                <label for="password">Password</label>
                <v-ons-input
                    input-id="password"
                    placeholder=""
                    v-model="password"
                    type="password"
                    class="text-input__container"
                    ></v-ons-input>
            </div>

            <div class="form-buttons">
                <button type="submit"
                    @click="() => authenticate()"
                    class="button button--primary"
                    ripple>
                    Login
                </button>
            </div>

            <div>
                <v-ons-button
                    @click="$router.push({ name: 'register' })"
                    modifier="cta">
                    Register here
                </v-ons-button>
            </div>

            <div>
                <v-ons-button
                    @click="forgotPassword"
                    modifier="quiet">
                    Forgot password
                </v-ons-button>
            </div>
        </form>

    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'
import PushNotification from './mixins/PushNotification'

export default {
    name: 'login',

    data () {
        return {
            email: '',
            password: '',
            loading: false,
        }
    },

    created() {
        this.remember()

        if (this.customer.content.id) {
            let redirectRoute = _.get(window, '_redirectRoute', { name: 'home' })
            _.set(window, '_redirectRoute', null)

            this.$nextTick(() => {
                this.$router.push(redirectRoute)
            })
        }

        this.$emit('init', {
            name: 'login',
            title: 'Login',
            showMenu: false,
        })
    },

    mixins: [
        Utils,
        PushNotification,
        Module('login'),
        Module('customer'),
    ],

    methods: {
        authenticate(token = null, notify = true, registerDevice = true) {
            let authData = token ? { token } : {
                email: this.email,
                password: this.password,
            }

            this.loading = true
            return this.api.postData('/my/auth', {}, authData)
                .then((login) => {
                    this.signin(login)
                    this.applyTheme(login)
                    this.$router.push({ name: 'home' })
                    if (registerDevice) {
                        this.registerDevice(this.customer.content.id)
                    }
                }).catch((err) => {
                    if (notify) {
                        this.notification_push({
                            type: 'error',
                            message: _.get(err, 'response.data.message', 'Something went wrong'),
                        })
                    }
                }).finally(() => {
                    this.loading = false;
                })
        },

        signin(login) {
            this.login.setContent(login)
            this.customer.setContent(_.get(login, 'included.parent', {}))
            window.localStorage.setItem('login', JSON.stringify(login))
            this.setToken(login.token)
        },

        applyTheme(login) {
            const customer = _.get(login, 'included.parent', {});
            const customerType = _.get(customer, 'attributes.customer_type', 'Gold');
            document.body.classList.add(`theme-${customerType.toLowerCase()}`)
        },

        remember() {
            let login = JSON.parse(window.localStorage.getItem('login'))
            if (login) {
                this.setToken(login.token)
                this.authenticate(login.token, false, false)
            }
        },

        forgotPassword() {
            // let env = this.helpers('env');
            // window.location.href = `${env.rootPath}/retrieve-password`;
            this.$router.push({ name: 'reset-password' })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    text-align: center;
    padding: 5rem 0 1rem 0 !important;
}
.login-form{
    padding: 0 24px;
}
img {
    max-width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginPage.vue